export default __webpack_public_path__ + "static/Verwaltung-8db8cc57c198f11640ef91166f703123.webp";